import { appTypes } from '../constants/action-types'

const initialState = {
  success: null,
  error: null
}

export const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case appTypes.APPREDUCER_ALERT_REQUEST:
      return {
        ...state,
        success: null,
        error: null
      }
    case appTypes.APPREDUCER_ALERT_SUCCESS:
      return {
        ...state,
        success: action.payload
      }
    case appTypes.APPREDUCER_ALERT_FAILURE:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default appReducer
